import { useCallback } from "react"
import { Column } from "react-table"
import { PolyLineCommand } from "lib/commands/primitives/polyline"
import { GraphicProcessor } from "lib/graphic-processor"
import { IPoint } from "lib/math/types"
import { LineData } from "lib/models/primitives/line"
import { cadOpType } from "lib/operations/factory"
import { PolyLineOP } from "lib/operations/primitive/polyline"
import ToolbarButton from "modules/cad/components/toolbar/toolbar-button"
import PolylineIcon from "shared/components/icons/polyline"
import Section from "shared/components/ui/section"
import Table from "shared/components/ui/table/table"

const columns: Column<{}>[] = [
  { Header: "Vertex", accessor: "indx" },
  { Header: "X (m)", accessor: "x" },
  { Header: "Y (m)", accessor: "y" },
];
export interface capDataTable {
  indx: number;
  x: string;
  y: string;
}

interface Props {
  graphicProc: GraphicProcessor;
  dataTable: capDataTable[];
  isDefault: boolean;
  updateCapData(rowIndex: number, pto: IPoint): void;
  addCapData(data: LineData): void;
}

const CapTableCoordinates = ({ graphicProc, dataTable, isDefault, updateCapData, addCapData }: Props) => {

  const updateData = useCallback((rowIndex: number, columnId: keyof capDataTable, value: string) => {
    const key = columnId as "x" | "y";
    const val = parseFloat(value);
    const pto = { ...dataTable[rowIndex], [key]: val }
    updateCapData(rowIndex, { x: parseFloat(pto.x), y: parseFloat(pto.y), z: 0 });
  }, [dataTable, updateCapData]);

  const launchContourCapOP = () => {
    const op = graphicProc.launchOP<typeof PolyLineOP>(cadOpType.POLYLINE);
    if (op) {
      op?.changeCloseOpen();
      op.endOperationCallback = (cmd: PolyLineCommand) => {
        const data = cmd.createdData;
        data.graphicObj.renderOrder = 1;
        addCapData(data);
      }
    }
  }

  return (
    <Section
      title="Contour coordinates"
      className={"whitespace-nowrap text-gray-400"}
      withBorder={false}
      optionalComponent={!isDefault && dataTable.length === 0 &&
        <ToolbarButton onClick={launchContourCapOP} tooltip="Add contour cap">
          <PolylineIcon />
        </ToolbarButton>
      }>
      {dataTable.length ?
        <Table
          columns={columns}
          data={dataTable}
          updateMyData={updateData}
        />
        : <p>Cap Contour not defined</p>
      }
    </Section>
  )
}

export default CapTableCoordinates;